"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReloadBanner = (_temp2 = _class = function (_Component) {
  _inherits(ReloadBanner, _Component);

  function ReloadBanner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReloadBanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReloadBanner.__proto__ || Object.getPrototypeOf(ReloadBanner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indexPage: "",
      needReload: false,
      request: null,
      timer: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReloadBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.sendRequestDelayed(this.props.initialDelay);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var updateInterval = nextProps.updateInterval;
      var needReload = nextState.needReload,
          timer = nextState.timer,
          request = nextState.request;


      if (!needReload && !timer && !request) {
        this.sendRequestDelayed(updateInterval);
      }

      return needReload;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanState();
    }
  }, {
    key: "cleanState",
    value: function cleanState() {
      var _state = this.state,
          request = _state.request,
          timer = _state.timer;

      if (timer !== null) {
        clearTimeout(timer);
      }

      if (request !== null) {
        request.abort();
      }
    }
  }, {
    key: "sendRequest",
    value: function sendRequest() {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.open("GET", this.props.url || window.location.origin);
      request.addEventListener("load", function (evt) {
        var _evt$target = evt.target,
            responseText = _evt$target.responseText,
            responseStatus = _evt$target.status;


        var indexPage = "";
        var needReload = false;
        if (responseStatus == 200) {
          indexPage = responseText;
          if (_this2.state.indexPage && _this2.state.indexPage !== indexPage) {
            needReload = true;
          }
        }

        _this2.setState({
          indexPage: indexPage,
          needReload: needReload,
          request: null
        });
      });
      request.send();

      return request;
    }
  }, {
    key: "sendRequestDelayed",
    value: function sendRequestDelayed(delay) {
      var _this3 = this;

      this.cleanState();

      this.setState({
        timer: setTimeout(function () {
          _this3.setState({
            timer: null,
            request: _this3.sendRequest()
          });
        }, delay)
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.needReload) {
        return null;
      }

      var className = this.props.className;

      var refreshLinkNode = _react2.default.createElement(
        "a",
        { href: this.props.refreshUrl || window.location.href },
        "refresh"
      );

      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)("erg-components-ReloadBanner erg-reload-banner", className) },
        "A new version of this app is now available! Please ",
        refreshLinkNode,
        " the page to load the latest version."
      );
    }
  }]);

  return ReloadBanner;
}(_react.Component), _class.displayName = "ReloadBanner", _class.propTypes = {
  className: _propTypes2.default.string,
  initialDelay: _propTypes2.default.number,
  refreshUrl: _propTypes2.default.string,
  updateInterval: _propTypes2.default.number,
  url: _propTypes2.default.string
}, _class.defaultProps = {
  initialDelay: 5000,
  updateInterval: 60000
}, _temp2);
exports.default = ReloadBanner;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/ReloadBanner.js
 ** module id = 789
 ** module chunks = 0
 **/